// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

export function newGuid(): string {
    function guidAtom(): string {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return `${guidAtom()}${guidAtom()}-${guidAtom()}-${guidAtom()}-${guidAtom()}-${guidAtom()}${guidAtom()}${guidAtom()}`.toUpperCase();
}
